export const Theme = {
  PRIMARY_COLOR: '#36A146',
  SECONDARY_COLOR: '#FFC412',
  ACTIVE1_COLOR: '#5f712d',
  ACTIVE2_COLOR: '#bd5319',
  PRIMARY_TEXT_COLOR: '#ffffff',
  SECONDARY_TEXT_COLOR: '#1114A4',
  DESCRIPTION_TEXT_COLOR: '#d6d6d6',
  TOP_BAR_COLOR: '#ffffff',
  ACTIVE_ITEM_BG_COLOR: '#1114A4',
  BG_COLOR: '#ecf0f1'
};
